export { extractPageNumber, isApiUrl, buildDocumentUrl } from "@noa/api-client";
import { openDocument as _openDocument } from "@noa/api-client";

export const openDocument = (url: string): void =>
  _openDocument(url, (u) => window.open(u, "_blank", "noopener,noreferrer"));
